import { Signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'

import { Observable, filter, map, take } from 'rxjs'

/**
 * Emits once, then completes, as soon as `loading` is false: a guard waits on it for what it checks
 * to finish loading. Call it in an injection context.
 *
 * TODO let the guards return a signal instead once Angular supports it
 */
export const whenLoaded = (loading: Signal<boolean>): Observable<void> =>
  toObservable(loading).pipe(
    filter((isLoading) => !isLoading),
    take(1),
    map(() => undefined)
  )
